import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Clock, Zap, Heart, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
export function PricingSection() {
  return <>
      <SectionWrapper id="pricing" className="text-center px-4 md:px-0" data-id="element-110">
        <div className="bg-white border-2 border-brand-blue rounded-2xl md:rounded-[2rem] p-6 md:p-16 relative shadow-[0_0_40px_rgba(37,99,235,0.15)] max-w-2xl mx-auto w-full" data-id="element-111">
          <div className="absolute -top-4 md:-top-6 left-1/2 -translate-x-1/2 bg-brand-blue text-white px-4 md:px-6 py-1.5 md:py-2 rounded-full font-bold flex items-center gap-1.5 md:gap-2 shadow-lg text-[11px] md:text-base whitespace-nowrap" data-id="element-112">
            <Clock className="w-3.5 h-3.5 md:w-5 md:h-5" data-id="element-113" /> PRECIO DE
            LANZAMIENTO
          </div>

          <div className="mt-6 md:mt-8 mb-6 md:mb-8" data-id="element-114">
            <p className="text-orange-500 font-bold flex items-center justify-center gap-1.5 mb-3 text-xs md:text-base" data-id="element-115">
              ⚠️ Precio actual por tiempo limitado
            </p>

            <CountdownTimer data-id="element-116" />

            <div className="text-5xl md:text-7xl font-black text-brand-navy mb-1 md:mb-4 tracking-tight mt-4" data-id="element-117">
              $19.990{' '}
              <span className="text-xl md:text-2xl text-brand-textLight font-bold" data-id="element-118">
                ARS
              </span>
            </div>
            <p className="text-sm md:text-xl text-brand-textLight font-medium" data-id="element-119">
              👉 Después aumenta
            </p>
          </div>

          <div className="bg-slate-50 rounded-xl md:rounded-2xl p-4 md:p-6 border border-slate-200 mb-6 md:mb-10 inline-block text-left w-full md:w-auto" data-id="element-120">
            <p className="font-bold text-brand-blue flex items-center gap-2 mb-2 md:mb-2 text-sm md:text-base" data-id="element-121">
              <span className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-red-500 animate-pulse" data-id="element-122" />{' '}
              ACCESO INMEDIATO
            </p>
            <p className="text-brand-text text-[13px] md:text-base mb-1" data-id="element-123">
              Recibís el material en minutos
            </p>
            <p className="text-brand-text text-[13px] md:text-base" data-id="element-124">
              Listo para leer y aplicar
            </p>
          </div>

          <Button fullWidth className="py-4 md:py-5 text-[15px] md:text-xl" data-id="element-125">
            QUIERO ACCEDER AHORA
          </Button>
        </div>
      </SectionWrapper>

      <SectionWrapper className="px-4 md:px-0" data-id="element-126">
        <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-127">
          <div className="bg-white shadow-xl rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-128">
            <div className="flex items-center gap-2 md:gap-3 mb-5 md:mb-8" data-id="element-129">
              <Heart className="w-6 h-6 md:w-8 md:h-8 text-red-500" data-id="element-130" />
              <h3 className="text-xl md:text-2xl font-extrabold text-brand-navy" data-id="element-131">
                LO QUE MÁS IMPACTA
              </h3>
            </div>
            <p className="text-brand-textLight mb-3 md:mb-4 text-sm md:text-base" data-id="element-132">
              Muchos padres creen que:
            </p>
            <p className="text-base md:text-xl font-bold text-brand-navy mb-5 md:mb-8 bg-slate-50 p-3 md:p-4 rounded-xl border border-slate-200" data-id="element-133">
              👉 "Mi hijo no haría eso"
            </p>
            <p className="text-brand-textLight mb-3 md:mb-4 text-sm md:text-base" data-id="element-134">
              Pero la realidad es:
            </p>
            <div className="space-y-2 md:space-y-3" data-id="element-135">
              <p className="text-base md:text-xl font-bold text-brand-blue" data-id="element-136">
                👉 No siempre es lo que hace
              </p>
              <p className="text-base md:text-xl font-bold text-brand-blue" data-id="element-137">
                👉 Es lo que le pasa
              </p>
            </div>
          </div>

          <div className="bg-white shadow-xl rounded-2xl md:rounded-3xl p-5 md:p-10" data-id="element-138">
            <div className="flex items-center gap-2 md:gap-3 mb-5 md:mb-8" data-id="element-139">
              <ShieldCheck className="w-6 h-6 md:w-8 md:h-8 text-brand-blue" data-id="element-140" />
              <h3 className="text-xl md:text-2xl font-extrabold text-brand-navy" data-id="element-141">
                GARANTÍA 7 DÍAS
              </h3>
            </div>
            <div className="space-y-4 md:space-y-6 text-base md:text-lg text-brand-text" data-id="element-142">
              <p className="font-bold text-brand-navy text-lg md:text-xl" data-id="element-143">
                Lo leés. Lo aplicás.
              </p>
              <p className="text-sm md:text-base" data-id="element-144">Si no es lo que esperabas:</p>
              <p className="text-base md:text-xl font-bold text-brand-blue bg-blue-50 p-3 md:p-4 rounded-xl inline-block" data-id="element-145">
                👉 devolución total
              </p>
              <p className="text-brand-textLight font-medium text-sm md:text-base" data-id="element-146">
                Sin preguntas.
              </p>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </>;
}